import * as z from "zod";

export const apiExtBookingChangeData = z.object({
  before: z.record(z.string(), z.string()),
  after: z.record(z.string(), z.string()),
});

export type ApiExtBookingChangeData = z.infer<typeof apiExtBookingChangeData>;
